export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=b3160d04&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/requests/view/index.vue?vue&type=template&id=b3160d04&
// module id = 1112
// module chunks = 0